import { Box, Fade, Tab, Tabs, useTheme } from '@mui/material';
import { isEmptyArray } from '@vy/utils';
import React, { useState } from 'react';
import { TabPanel } from './components/TabPanel';

type TabItem = {
  label: string;
  render: () => React.ReactElement;
  actions?: React.ReactNode;
};

type VyTabsProps = {
  tabs: TabItem[];
  defaultTabIndex?: number;
};

export const VyTabs: React.FC<VyTabsProps> = ({ tabs, defaultTabIndex = 0 }) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(defaultTabIndex);
  const theme = useTheme();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTabIndex(newValue);
  };

  if (isEmptyArray(tabs)) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: 'white',
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Tabs
          value={currentTabIndex}
          onChange={handleTabChange}
        >
          {tabs.map((tab, index) => (
            <Tab key={`${tab.label}-tab`} label={tab.label} value={index} />
          ))}
        </Tabs>

        {tabs[currentTabIndex]?.actions && (
          <Box sx={{ display: 'flex', gap: 1.5, pr: 2 }}>
            {tabs[currentTabIndex].actions}
          </Box>
        )}
      </Box>

      <Box sx={{ flexGrow: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        {tabs.map((tab, index) => (
          <TabPanel key={`${tab.label}-tab-panel`} hidden={currentTabIndex !== index}>
            <Fade in={currentTabIndex === index}>
              <div style={{ height: '100%', width: '100%' }}>{tab.render()}</div>
            </Fade>
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
};
